import type { Graphic } from '@/features/graphics';
import {
  type GraphicFailureCopy,
  describeGraphicFailure,
} from '@/features/graphics/graphic-failure';

type GalleryGraphic = Pick<
  Graphic,
  'status' | 'outputs' | 'errorCode' | 'errorMessage'
>;

/** Whether the gallery lists this graphic. */
export function showsInGallery(graphic: GalleryGraphic): boolean {
  return graphic.status === 'ready' && Boolean(graphic.outputs?.[0]?.url);
}

/**
 * Why a graphic failed, for the tile and preview that stand in for its image.
 * A failed graphic reads as failed even if some slides rendered, so it is never
 * offered for posting. Null when the graphic did not fail.
 */
export function failedGraphicCopy(
  graphic: GalleryGraphic
): GraphicFailureCopy | null {
  if (graphic.status !== 'failed') return null;
  return describeGraphicFailure(
    graphic,
    'This graphic could not be generated. Edit it with Claire to try again.'
  );
}
